import { Breadcrumbs } from 'AbstractElements';
import SubMateriContain from 'Component/Learning/SubMateri';

const LearningList = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Learning List" grandparent="Learning" parent="Materi" title="Daftar Submateri" />
      <SubMateriContain />
    </>
  );
};
export default LearningList;